<template>
    <transition name="fade">
        <div class="col-sm-12 type-overlay" v-if="visible">
            <div class="type-modal">
                <div class="type-body">
                    <h2>diesel oder benziner?</h2>
                    <p>Wählen Sie jetzt bitte Typ / Motor Ihres Autos.</p>
                    <template v-for="carType in types">
                        <table class="table">
                            <colgroup>
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                                <col width="25%" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th colspan="4">{{ carType.fuelType }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="typeOptions in carType.children">
                                    <template v-for="chunks in chunk(typeOptions.grandchildren)">
                                        <tr>
                                            <template v-for="{id, name, seo} in chunks">
                                                <td :data-id="id" :data-car="carId" :data-carseo="seo" @click="onSelected">
                                                    {{ name }}
                                                </td>
                                            </template>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </template>
                    <div class="close" @click="closeModal">x</div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  props: {
        carId: {
            type: [String, Number],
            required: true,
            default: null
        },
        types: {
            default: []
        }
    },

    data() {
        return {
            visible: false,
            type: null,
            carseo: null
        }
    },

    methods: {
        onSelected({currentTarget}) {
            this.visible = false;
            this.type = currentTarget.dataset.id;
            this.carseo = currentTarget.dataset.carseo;

            App.event.fire('car.type.selected', {
                type: this.type,
                carseo: this.carseo,
                car: this.carId
            });

            new Form({id: this.type})
                .post('/api/categories')
                .then((categories) => {
                    App.event.fire('car.categories.loaded', categories);
                });

        },

        closeModal() {
            this.visible = false;
        },

        chunk(items) {
            
            // Conver object to array
            items = _.values(items); 

            var sets = [], chunks, i = 0, chunkSize = 4;
            chunks = items.length / chunkSize;

            // Split array in to chunks
            while(i < chunks){
                sets[i] = items.splice(0, chunkSize);
                i++;
            }
            
            // Fill last item to be the same size as others
            if (sets.length) {
                let lastChunk = sets[sets.length - 1];
                if (lastChunk.length < chunkSize) {
                    for (let j = lastChunk.length; j < chunkSize; j++) {
                        lastChunk[lastChunk.length] = {};
                    }
                }
            }

            return sets;
        }
        
    },

    created() {
        App.event.listen('car.open.years', (id) => {
            this.visible = false;
        });                
        App.event.listen('car.open.types', (id) => {
            this.visible = (this.types.length && id == this.carId);
        });                
        App.event.listen('car.types.loaded', ({types, car}) => {
            // this.types = (car == this.carId) ? types : [];
            this.visible = (car == this.carId);
        });                
    }
}
</script>
